import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CardHeader, CardContent, Divider, Stack, Typography, IconButton } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';

export const ParticipantsForm = ({ formik }) => {
  const { seasonIdentifier, seasonYear } = useSelector(state => state.app);

  const handleChildrenChange = (field, increase = true) => {
    // Pobieramy aktualną wartość pola
    const prevArray = Array.isArray(formik.values[field]) ? formik.values[field] : [];

    // Tworzymy nową tablicę
    const newCount = increase ? prevArray.length + 1 : Math.max(prevArray.length - 1, 0);
    const newArray = [...prevArray];

    if (increase) {
      newArray.push(0); // Dodajemy nowy element z domyślną wartością 0
    } else {
      newArray.pop(); // Usuwamy ostatni element
    }

    // Ustawiamy nową wartość w Formiku
    formik.setFieldValue(field, newArray);
  };

  return (
    <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2, flex: '1 1 50%' }}>
      <CardHeader title="Dane uczestników" sx={{ pb: 1 }} />
      <Divider />
      <CardContent>
        <Stack spacing={3} p={2}>
          <ParticipantField
            label="Liczba dorosłych"
            name="wr_adults_count"
            formik={formik}
          />
          <Divider />
          {seasonYear < 2026 && <ChildrenField
            label="Liczba dzieci od 3 do 12 lat"
            field="wr_3_12_children_age"
            formik={formik}
            handleChildrenChange={handleChildrenChange}
          />}
          <Divider />
          {seasonYear < 2026 && <ChildrenField
            label="Liczba dzieci poniżej 3 lat"
            field="wr_0_3_children_age"
            formik={formik}
            handleChildrenChange={handleChildrenChange}
          />}
          {seasonYear >= 2026 && <ChildrenField
            label="Liczba dzieci powyżej 6 lat"
            field="wr_6_plus_children_age"
            formik={formik}
            handleChildrenChange={handleChildrenChange}
          />}
          <Divider />
          {seasonYear >= 2026 && <ChildrenField
            label="Liczba dzieci do 5 r. ż."
            field="wr_0_5_children_age"
            formik={formik}
            handleChildrenChange={handleChildrenChange}
          />}
        </Stack>
      </CardContent>
    </Card>
  );
};

const ParticipantField = ({ label, name, formik }) => (
  <Stack direction="row" alignItems="center" spacing={2}>
    <Typography variant="subtitle2" sx={{ flexShrink: 0 }}>{label}</Typography>
    <SmallFormTextField
      error={formik.errors[name] && formik.touched[name]}
      name={name}
      placeholder="Wpisz liczbę"
      value={formik.values[name]}
      onChange={formik.handleChange}
      helperText={formik.errors[name]}
      sx={{ width: '120px' }}
    />
  </Stack>
);

const ChildrenField = ({ label, field, formik, handleChildrenChange }) => (
  <Stack spacing={2}>
    <Stack direction="row" alignItems="center" spacing={2}>
      <Typography variant="subtitle2" sx={{ flexShrink: 0 }}>{label}</Typography>
      <IconButton onClick={() => handleChildrenChange(field, false)}>
        <Remove color="error"/>
      </IconButton>
      <SmallFormTextField disabled value={formik.values[field].length} sx={{ width: '50px' }} />
      <IconButton onClick={() => handleChildrenChange(field, true)}>
        <Add color="primary"/>
      </IconButton>
    </Stack>
    <Stack spacing={1}>
      {formik.values[field].map((age, index) => (
        <Stack key={`${field}-${index}`} direction="row" alignItems="center" spacing={2}>
          <Typography variant="subtitle2">Dziecko #{index + 1}</Typography>
          <SmallFormTextField
            name={`${field}.${index}`}
            placeholder={`Wiek dziecka ${index + 1}`}
            value={formik.values[field][index] || ''}
            onChange={formik.handleChange}
            // sx={{ width: '100' }}
          />
        </Stack>
      ))}
    </Stack>
  </Stack>
);
